import { styled } from "@linaria/react"

import { TitleFont } from "../../theme"
import Button from "../Button"
import { CardholderIcon } from "../CardholderIcon"

interface AOWalletConnectProps {
  activeAoAddress: string | undefined
  onConnect?: () => void
}

// Create text styles
const Heading = styled.h2`
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  font-family: ${TitleFont};
  text-align: center;
`

const BodyText = styled.div`
  font-size: 0.875rem;
  color: var(--mui-palette-text-secondary);
  text-align: center;
  max-width: 480px;
`

const SuccessText = styled.div`
  font-size: 0.875rem;
  color: #2e7d32; /* success.main color */
  font-weight: 500;
`

const MonoText = styled.div`
  font-family: monospace;
  font-size: 0.875rem;
`

export const AOWalletConnect = ({ onConnect, activeAoAddress }: AOWalletConnectProps) => {
  const handleConnect = () => {
    if (onConnect) onConnect()
  }

  return (
    <ConnectWrapper>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        {!activeAoAddress ? (
          <>
            <Heading>Connect your AO Wallet</Heading>
            <BodyText>
              Delegating your AO capacity enables you to participate
              <br />
              in the network and earn $BOTG tokens.
            </BodyText>
            <ConnectButton onClick={handleConnect} className="accent">
              Connect AO Wallet
              <CardholderIcon />
            </ConnectButton>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              alignItems: "center",
            }}
          >
            <BodyText>Connected as:</BodyText>
            <AddressPill>
              <MonoText>{formatWalletAddress(activeAoAddress)}</MonoText>
            </AddressPill>
            <SuccessText>✓ AO Wallet Connected</SuccessText>
          </div>
        )}
      </div>
    </ConnectWrapper>
  )
}

// Helper function to format wallet address
const formatWalletAddress = (address: string): string => {
  if (!address) return ""
  return `${address.substring(0, 8)}...${address.substring(address.length - 8)}`
}

const ConnectWrapper = styled.div`
  padding: 2rem;
  width: 100%;
  border-radius: var(--mui-shape-borderRadius);
  background-color: #fff;
  margin-top: 0.5rem;
`

const ConnectButton = styled(Button)`
  padding: 1.4rem 1.55rem;
  font-size: 1.2rem;
  margin-top: 1rem;
  min-width: 220px;
`

const AddressPill = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  background-color: var(--mui-palette-background-paper);
  border: 1px solid var(--mui-palette-borderSecondary);
`

export default AOWalletConnect
